import React from "react";
import "./projects.css";
import Pr_1 from "../../assets/projects/project_1.png";
import Pr_2 from "../../assets/projects/project_2.png";
import Pr_3 from "../../assets/projects/project_3.png";
import Pr_4 from "../../assets/projects/project_4.png";
import Pr_5 from "../../assets/projects/project_5.png";
import Pr_6 from "../../assets/projects/project_6.png";

const Projects = () => {
  return (
    <section id="projects">
      <h5>My Recent Work</h5>
      <h2>Projects</h2>
      <div className="container projects__container">
        <article className="project__card">
          <div className="project__img">
            <img src={Pr_1} alt="" />
          </div>
          <h3>Sales & Customers Analytics Dashboards</h3>
          <div className="project__card-cta">
            {/* <a href="https://github.com" className="btn" target="_blank">
              Github
            </a> */}
            <a
              href="https://public.tableau.com/app/profile/pi.poel/viz/tableau_project_17411032335240/SalesDashboard"
              className="btn"
              target="_blank"
            >
              Demo Live
            </a>
          </div>
        </article>

        <article className="project__card">
          <div className="project__img">
            <img src={Pr_2} alt="" />
          </div>
          <h3>MindTeach: AI-Powered Adaptive Learning</h3>
          <div className="project__card-cta">
            <a href="https://github.com/Youssef-0202/Project_Mobile_Fin_Module.git" className="btn" target="_blank">
              Github
            </a>
            {/* <a
              href="https://www.linkedin.com/posts/mohamed-bajadi-788227280_mindteach-ai-mobileapp-activity-7340823961611460609-hQTO?utm_source=share&utm_medium=member_desktop&rcm=ACoAAERgbZgBIEA4Ps1Dg63CDKqhAOSIbGtfiCE"
              className="btn btn-primary"
              target="_blank"
            >
              Demo
            </a> */}
          </div>
        </article>

        <article className="project__card">
          <div className="project__img">
            <img src={Pr_3} alt="" />
          </div>
          <h3>Customer Churn Prediction & Segmentation</h3>
          <div className="project__card-cta">
            <a href="https://github.com/mohamed-bajadi1/Customer_segmentation_and_churn_predection_using_ml.git" className="btn" target="_blank">
              Github
            </a>
            {/* <a
              href="https://public.tableau.com/app/profile/pi.poel/viz/tableau_project_17411032335240/SalesDashboard"
              className="btn btn-primary"
              target="_blank"
            >
              Demo
            </a> */}
          </div>
        </article>

        <article className="project__card">
          <div className="project__img">
            <img src={Pr_4} alt="" />
          </div>
          <h3>Real-time Driver Drowsiness Detection</h3>
          <div className="project__card-cta">
            <a
              href="https://github.com/mohamed-bajadi1/Real_Time_Driver_Drowsiness_Detection.git"
              className="btn"
              target="_blank"
            >
              Github
            </a>
            {/* <a
              href="https://public.tableau.com/app/profile/pi.poel/viz/tableau_project_17411032335240/SalesDashboard"
              className="btn btn-primary"
              target="_blank"
            >
              Demo
            </a> */}
          </div>
        </article>

        <article className="project__card">
          <div className="project__img">
            <img src={Pr_5} alt="" />
          </div>
          <h3>Fashion Image-Based Recommender System</h3>
          <div className="project__card-cta">
            <a href="https://github.com/Mustapha-Zmirli/Image-Based-Recommender-System-Project.git" className="btn" target="_blank">
              Github
            </a>
            {/* <a
              href="https://public.tableau.com/app/profile/pi.poel/viz/tableau_project_17411032335240/SalesDashboard"
              className="btn btn-primary"
              target="_blank"
            >
              Demo
            </a> */}
          </div>
        </article>

        <article className="project__card">
          <div className="project__img">
            <img src={Pr_6} alt="" />
          </div>
          <h3>System for Prioritizing Vulnerabilities</h3>
          <div className="project__card-cta">
            <a href="https://github.com/Mustapha-Zmirli/Recommendation-System-for-Intelligent-Vulnerability-Prioritization.git" className="btn" target="_blank">
              Github
            </a>
            {/* <a
              href="https://public.tableau.com/app/profile/pi.poel/viz/tableau_project_17411032335240/SalesDashboard"
              className="btn btn-primary"
              target="_blank"
            >
              Demo
            </a> */}
          </div>
        </article>
      </div>
    </section>
  );
};

export default Projects;
